import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormView, DialogModal } from ".";
import { hideDialog, showDialog } from "../../appRedux/actions/common";
import { deleteCourses } from "../../appRedux/actions/courses";

//
const BodyView = ({ info, isArchive }) => {
  const dispatch = useDispatch();
  const { queryInfo } = useSelector((state) => ({
    queryInfo: isArchive ? state.courses.inactiveQueryInfo : state.courses.queryInfo,
  }));

  return (
    <Fragment>
      {/* <p>Are you sure want to delete?</p> */}
      <div className="form-header">
        <h3>{info.status === "inactive" ? "Activate" : "Archive"} Course </h3>
        <p>
          Are you sure want to {info.status === "inactive" ? "activate" : "archive"} this course?
        </p>
      </div>
      <div className="modal-btn delete-action">
        <div className="row">
          <div className="col-6">
            <button
              onClick={() => dispatch(hideDialog())}
              className="btn btn-primary continue-btn"
              style={{ width: "100%" }}
            >
              Disagree
            </button>
          </div>
          <div className="col-6">
            <button
              onClick={() => {
                dispatch(hideDialog());
                // navigate(linkTo, { replace: true });
                dispatch(
                  deleteCourses({
                    courseId: info._id,
                    queryInfo,
                    status: info.status === "inactive" ? "active" : "inactive",
                    isArchive,
                  })
                );
              }}
              className="btn btn-primary cancel-btn"
              style={{ width: "100%" }}
            >
              Agree
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

function ArchiveModal({ info, isArchive }) {
  // const { info } = props;
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { dialog } = useSelector((state) => ({
    dialog: state.common.dialog,
  }));
  useEffect(() => {
    if (!dialog) {
      setOpen(dialog);
    }
  }, [dialog]);
  return (
    <Fragment>
      <button
        className="dropdown-item"
        onClick={() => {
          setOpen(true);
          dispatch(showDialog({ title: "", hideHeader: true }));
        }}
        key={"archive_course"}
      >
        {info.status !== "inactive" ? (
          <>
            <i className="fa fa-archive m-r-5" /> Archive
          </>
        ) : (
          <>
            <i className="fa fa-smile-o m-r-5" /> Activate
          </>
        )}
      </button>
      {open && <DialogModal bodyView={<BodyView info={info} isArchive={isArchive} />}></DialogModal>}
    </Fragment>
  );
}

export default ArchiveModal;
